import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../../../UI/Loader';

const MONTH_NAMES_SWEDISH = [
    "Januari", "Februari", "Mars",
    "April", "Maj", "Juni",
    "Juli", "Augusti", "September",
    "Oktober", "November", "December"
];

export default class PageLoader extends React.Component {
    static propTypes = {
        date: PropTypes.string
    }

    static defaultProps = {
        date: ''
    };

    render() {
        const theDate = new Date(this.props.date);

        let day = theDate.getDate()
        let month = MONTH_NAMES_SWEDISH[theDate.getMonth()]
        let year = theDate.getFullYear();

        if (isNaN(day)) {
            day = 'Felaktigt datum'
            month = '';
            year = '';
        }

        return (
            <React.Fragment>
                {day} {month} {year}
            </React.Fragment>
        )
    }
};

